import { render, staticRenderFns } from "./appBanners.vue?vue&type=template&id=49ed2797&scoped=true"
import script from "./appBanners.vue?vue&type=script&lang=js"
export * from "./appBanners.vue?vue&type=script&lang=js"
import style0 from "./appBanners.vue?vue&type=style&index=0&id=49ed2797&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ed2797",
  null
  
)

export default component.exports